module.exports = __webpack_public_path__ + "static/media/no-src.8a7ed537.png";